import { useState, createContext, useContext, ReactNode } from 'react';

interface FileManagerContextType {
  selectedFiles: File[];
  setSelectedFiles: (files: File[]) => void;
  clearFiles: () => void;
}

const FileManagerContext = createContext<FileManagerContextType | undefined>(undefined);

export const useFileManager = () => {
  const context = useContext(FileManagerContext);
  if (context === undefined) {
    throw new Error('useFileManager must be used within a FileManagerProvider');
  }
  return context;
};

interface FileManagerProviderProps {
  children: ReactNode;
}

export const FileManagerProvider = ({ children }: FileManagerProviderProps) => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const clearFiles = () => {
    setSelectedFiles([]);
  };

  const value = {
    selectedFiles,
    setSelectedFiles,
    clearFiles,
  };

  return (
    <FileManagerContext.Provider value={value}>
      {children}
    </FileManagerContext.Provider>
  );
};
